import { render, staticRenderFns } from "./site-header.vue?vue&type=template&id=0f2ef86b&"
import script from "./site-header.vue?vue&type=script&lang=js&"
export * from "./site-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports